export default {
  tabs: {
    fiintradeStrategy: 'Fiintrade Strategy',
    canslimStrategy: 'CANSLIM Strategy',
    taStrategy: 'TA Strategy',
  },
  common: {
    industry: 'Industry Ranking',
    group: 'Group Ranking',
  },
  listFiintrade: {
    overview: 'OVERVIEW',
    value: 'VALUE',
    growth: 'GROWTH',
    momentum: 'MOMENTUM',
    vgm: 'VGM',
    leaders: 'LEADERS',
  },
  listOverviewTable: {
    ticker: 'Ticker',
    roe: 'ROE(%)',
    roa: 'ROA(%)',
    pe: 'P/E',
    pb: 'P/B',
  },
  listValue: {
    timeRange: 'TIME RANGE',
    stockePicks: 'STOCK PICKS',
    vnIndex: 'VN-INDEX',
  },
  value: {
    calculated: `*Calculated on a 100,000,000 VND investment`,
  },
  fiinTradeRankingsHeader: {
    rtd11: 'Market Cap (Bn.)',
    rank: 'Rank',
    ticker: 'Ticker',
    industry: 'Industry',
    rankingHistory: 'Ranking History',
    ranking: 'Ranking',
    size: 'Size',
    profit: 'Profit',
    cashflow: 'Cashflow',
    valuation: 'Valuation',
    trading: 'Trading',
    analysisCover: 'Analysis Cover',
    allIndustries: 'Group',
    marketCap: 'Market Cap (Bn.)',
    value: 'Value',
    growth: 'Growth',
    momentum: 'Momentum',
    vgm: 'VGM',
  },
  visNameHeader: 'Value Investment Strategy',
  gisNameHeader: 'Growth Investment Strategy',
  misNameHeader: 'Momentum Investment Strategy',
  VMGNameHeader: 'VMG Investment Strategy',
  lisNameHeader: 'Leaders Investment Strategy',
  highNameHeader: 'HIGH RANKING & A-VALUE SCORE',
  growthNameHeader: 'HIGH RANKING & GROWTH SCORE',
  momentumNameHeader: 'HIGH RANKING & MOMENTUM SCORE',
  vmgNameHeader: 'HIGH RANKING & VGM SCORE',
  leaderNameHeader: 'HIGH RANKING IN SECTORS / STOCK GROUPS',
  titleChart: 'CUMULATIVE GROWTH',
  titleLegendChartValue: 'Value Investment Strategy Stock Picks',
  titleLegendChartGrowth: 'Growth Investment Strategy Stock Picks',
  titleLegendChartMomentum: 'Momentum Investment Strategy Stock Picks',
  titleLegendChartVMG: 'VMG Investment Strategy Stock Picks',
  titleLegendChartLeaders: 'Leaders Investment Strategy Stock Picks',
  tooltipValue: 'Value Investment Strategy Stock Picks: ',
  tooltipGrowth: 'Growth Investment Strategy Stock Picks: ',
  tooltipMomentum: 'Momentum Investment Strategy Stock Picks: ',
  tooltipVMG: 'VMG Investment Strategy Stock Picks: ',
  tooltipLeaders: 'Leaders Investment Strategy Stock Picks: ',
  tooltipVnIndex: 'VN-INDEX: ',
  return: 'Return',
  vnIndex: 'VN-INDEX',
  million: 'Million VND',
  vis: 'VIS',
  gis: 'GIS',
  mis: 'MIS',
  vmg: 'VMG',
  lis: 'LIS',
  strCalculated:
    '*Calculated by average return of all recommended stocks (cumulative over the past 10 years)',
  topFiveLeader: 'TOP 5 OF LEADERS',
  topFiveValue: 'TOP 5 OF VALUE',
  topFiveGrowth: 'TOP 5 OF GROWTH',
  topFiveMomentum: 'TOP 5 OF MOMENTUM',
  AllIndustries: 'All Industries',
  year: 'year',
  years: 'years',
  oneYear: 'year',
};
